<template>
    <common-modal v-if="isOpen" width="large" height="full" @close="$emit('close')">
        <download-timeline :appointments="appointments" @download-pdf="$emit('close')"></download-timeline>
    </common-modal>
</template>

<script>
    import DownloadTimeline from '@/components/page-elements/DownloadAppointmentTimeline.vue'

    export default {
        components: { DownloadTimeline },
        props: {
            isOpen: { type: Boolean, default: false },
            appointments: { type: Array, default: () => [] },
        },
    }
</script>
